import { render, staticRenderFns } from "./CallMobileSmsTemplate.vue?vue&type=template&id=2326be40"
import script from "./CallMobileSmsTemplate.vue?vue&type=script&lang=js"
export * from "./CallMobileSmsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports